import TooltipPopover from './TooltipPopover';
import Dropdown from './Dropdown';

interface CurrencyDropdownProps {
  options: string[];
  value: string;
  onOptionChange: (value: string) => void;
  onClear: () => void;
  isRequired?: boolean;
  isDisabled?: boolean;
  isAdsAccount?: boolean;
}

function CurrencyDropdown({
  options,
  value,
  onOptionChange,
  onClear,
  isRequired = false,
  isDisabled = false,
  isAdsAccount = false,
}: CurrencyDropdownProps) {
  const clearCurrency = () => {
    onClear();
  };

  return (
    <div className="flex flex-col gap-2 items-start">
      <label className="text-primarygray font-bold inline-flex items-center gap-1 relative">
        <TooltipPopover
          type="info"
          content="Select the currency used in your Google Ads and Microsoft Ads accounts. This currency will be applied across OneSearch."
          className={
            isRequired && isAdsAccount
              ? 'top-1 left-[90px]'
              : 'top-1 left-[80px]'
          }
          side="top"
        >
          Currency {isRequired && isAdsAccount ? '*' : ''}
        </TooltipPopover>
      </label>
      <div className="flex gap-2 items-center">
        <Dropdown
          title={`${value}`}
          options={options}
          dropdownOuterWidth="w-72"
          dropdownWidth="w-96"
          onOptionClick={onOptionChange}
          disabled={isDisabled}
          value={value}
        />
        <button className="text-xs inline font-bold" onClick={clearCurrency}>
          Reset
        </button>
      </div>
      {isAdsAccount && isRequired && !value && (
        <span className="text-error text-sm">Currency is required.</span>
      )}
      {!isAdsAccount && value && (
        <span className="text-error text-sm">
          Must include Google Ads and/or Microsoft Ads account in the form
          fields.
        </span>
      )}
    </div>
  );
}

export default CurrencyDropdown;
